module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av127-06ef42b133605eec75a2dca288138b89.jpg";